var _ = require("underscore");
var JsonParser = require("./src/datamodel/jsonParser.js");

var logError = require("./error.js");
require("setimmediate");

// Compressor
var EventsCompressor = function(config){
    this.factor = config.factor;
    this.types = config.types;

    this.queue = [];
    this.enableCompress = false;

    GuiEvents.addEvents({
        COMPRESSED_MOVES: {id: 'cpm_1', name: "COMPRESSED_MOVES"}
    });
};

module.exports.EventsCompressor = EventsCompressor;


// Accumulate move events (of a certain type) until another event comes along or the queue is full.
EventsCompressor.prototype.compress = function(guiEvent, emit)
{
    // when nothing to do, emit every event as is
    if ( ! this.enableCompress ) {
        emit(guiEvent);
        return;
    }

    var type = guiEvent.type().name;
    var match = this.types.indexOf(type) >= 0;

    // when the move event matches, store the event up to a certain number, and keep place for that last move event.
    if ( match && this.queue.length < this.factor - 1) {
        this.queue.push(guiEvent);
        return;
    }

    // when nothing in the mouse move queue, just emit event
    if (this.queue.length == 0) {
        emit(guiEvent);
        return;
    }

    // Here we know we accumulated some moves that we have to purge first

    // Add that last move event to the queue to get the max amount of amortized moves
    if (match && this.queue.length == this.factor - 1) {
        this.queue.push(guiEvent);
    }

    // squash move events in to 1 event
    var events = [];
    this.queue.forEach(function(event){
        var coord = event.data('mouseCoord');
        events.push([ coord.x, coord.y, event.timestamp(), event.type().id ]);
    });

    var moveEvent = new GuiEvent(GuiEvents.COMPRESSED_MOVES);
    // Set time of this event to first mousemove event in queue
    moveEvent._timestamp = this.queue[0]._timestamp;
    moveEvent._start_ts = this.queue[0]._start_ts;
    moveEvent._order = this.queue[0]._order;
    moveEvent.data( 'mouse_moves', events );

    // reset queue
    this.queue = [];

    // emit events
    emit(moveEvent);

    // emit the event that triggered this only if it is not a mouse move event
    if (!match) {
        emit(guiEvent);
    }
};

/*jshint -W069 */
/*Disable Warning Justification:
 Using bracket notation so Google Closure Compiler
 ADVANCED_OPTIMIZATIONS will keep the original property names. */
EventsCompressor.prototype.decompress = function(recording)
{
    var decompressed = [];
    recording['events'].forEach(function(event) {

            if (event['name'] != "COMPRESSED_MOVES") {
                decompressed.push(event);
                return;
            }

           event['data']['mouse_moves'].forEach(function(mouse_move){
                var x = mouse_move[0],
                    y = mouse_move[1],
                    timestamp = mouse_move[2],
                    id = mouse_move[3],
                    name = GuiEvents.findEvent(id).name;

                decompressed.push({
                    "name": name,
                    "type": "abs_2",
                    "data": {
                        "metaKey": false,
                        "ctrlKey": false,
                        "shiftKey": false,
                        "which": 0,
                        "pageX": 0,
                        "pageY": 0,
                        "mouseCoord": {
                            "x": x,
                            "y": y
                        }
                    },
                    "element": {},
                    "timestamp": timestamp
                });
            });
    });

    recording.events = decompressed;

    return recording;
};

EventsCompressor.prototype.decompressEvent = function(event, cb)
{
    if (event['name'] != "COMPRESSED_MOVES") {
        cb(event);
        return;
    }

    event['data']['mouse_moves'].forEach(function(mouse_move){

        var x = mouse_move[0],
            y = mouse_move[1],
            timestamp = mouse_move[2],
            id = mouse_move[3],
            name = GuiEvents.findEvent(id).name;

        cb({
            "name": name,
            "type": "abs_2",
            "data": {
                "metaKey": false,
                "ctrlKey": false,
                "shiftKey": false,
                "which": 0,
                "pageX": 0,
                "pageY": 0,
                "mouseCoord": {
                    "x": x,
                    "y": y
                }
            },
            "element": {},
            "timestamp": timestamp
        });
    });
};
/*jshint +W069 */

// Array base storage class
var RecorderArrayStore = function()
{
    this.guiEvents = [];
};

module.exports.RecorderArrayStore = RecorderArrayStore;

RecorderArrayStore.prototype.addEvent = function(guiEvent)
{
    this.guiEvents.push(guiEvent);
};

RecorderArrayStore.prototype.getRecording = function(resolve)
{
    var events = [];

    this.guiEvents.forEach(function(guiEvent){
        events.push(guiEvent.serialize());
    });

    resolve(
        null, {
            "version": "3",
            "events": events
        }
    );
};

var QueuedTask = function(handler, failureHandler){
    this.handler = handler;
    this.failureHandler = failureHandler;
    this.batchSize = 10;
    this.queue = [];
};

QueuedTask.prototype.run = function(){
    var self = this;
    setTimeout(function() {
        self.handler(self.queue.splice(0, self.batchSize), function (error) {
            if (error) {
                if (self.failureHandler(error)){
                    return;
                }
            }
            if (self.queue.length > 0) {
                self.run();
            }
        });
    }, 1);
};

QueuedTask.prototype.push = function(payload){
    this.queue.push(payload);
    if (this.queue.length === 1){
        this.run();
    }
};

var RecorderSquidStore = function(options)
{
    this.endpoint = options.endpoint;
    this.afc = options.afc;
    this.version = 1;
    this.in_error_mode = false;
    this.compressor = new EventsCompressor({
        types: [ 'EDITOR_MOUSE_MOVE', 'CANVAS_MOUSE_MOVE' ],
        factor: 50
    });

    var self = this;

    var handler = function(payloads, callback){
        var storings = [];
        payloads.forEach(function (payload) {
            storings.push(
                $.ajax({
                    url: self.endpoint,
                    type: 'post',
                    contentType: 'application/json',
                    dataType: 'json',
                    data: JSON.stringify(payload)
                })
            );
        });

        $.when.apply(this, storings)
            .done(function (data, textStatus, jqXHR) {
                callback(null);
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                callback(errorThrown);
            });
    };

    var failureHandler = function(error){
        try {
            self.in_error_mode = true;
            if (! _.isEmpty(logError)) {
                logError("Recorder", error, logError.criticality.TRIVIAL);
            }
        }
        finally {
            self.in_error_mode = false;
        }
        return true; // Stop recording when an error occurs storing the recorder.
    };

    this.queue = new QueuedTask(handler, failureHandler);
};

module.exports.RecorderSquidStore = RecorderSquidStore;

RecorderSquidStore.prototype._store = function(share_id, user_id, timestamp, type, payload) {

    if (this.in_error_mode){
        return;
    }

    var d = new Date(timestamp);
    var formattedTimestamp = (function(date){
        var y = date.getFullYear();
        var m = ("0" + (date.getMonth() + 1)).slice(-2);
        var d = ("0" + date.getDate()).slice(-2);
        var H = ("0" + date.getHours()).slice(-2);
        var M = ("0" + date.getMinutes()).slice(-2);
        var S = ("0" + date.getSeconds()).slice(-2);
        var MS = date.getMilliseconds();
        return y + '-' + m + '-' + d + 'T' + H + ':' + M + ':' + S + '.' + MS;
    })(d);

    var data = [{
        'afc': this.afc,
        'event_type': 'app.command',
        'timestamp': formattedTimestamp,
        'version': this.version,
        'session_id': share_id,
        'member_id': user_id,
        'command': type,
        'command_data': JSON.stringify(payload)
    }];

    this.queue.push(data);
};

RecorderSquidStore.prototype.addEvent = function(share_id, user_id, guiEvent)
{
    this._store(share_id, user_id, guiEvent._timestamp, 'evt', guiEvent.serialize());
};

RecorderSquidStore.prototype.storeException = function(share_id, user_id, message, error) {
    var payload = {
        message: message,
        error: {
            message: error.message,
            stack: error.stack,
            type: error.type
        }
    };
    this._store(share_id, user_id, Date.now(), 'err', payload);
};


var RecorderStore = function(recordInMemory)
{
    this.recordInMemory = recordInMemory;
    this.arrayStore = new RecorderArrayStore();
    this.squidStore = null;
    this.start_ts = new Date().getTime();
    this.order = 0;
    this.compressor = new EventsCompressor({
        types: [ 'EDITOR_MOUSE_MOVE', 'CANVAS_MOUSE_MOVE' ],
        factor: 50
    });
};

module.exports.RecorderStore = RecorderStore;

RecorderStore.prototype.persist = function(options)
{
    this.squidStore = new RecorderSquidStore(options);
    this.recording = true;
};

RecorderStore.prototype.addEvent = function(share_id, user_id, guiEvent)
{
    var self = this;
    guiEvent._start_ts = this.start_ts;
    guiEvent._order = this.order;
    this.order += 1;

    self.compressor.compress(guiEvent, function(event) {

        if (self.recordInMemory) {
            self.arrayStore.addEvent(event);
        }

        if (self.squidStore) {
            self.squidStore.addEvent(share_id, user_id, event);
        }

    });
};

RecorderStore.prototype.storeException = function(share_id, user_id, message, error)
{
    if (this.squidStore) {
        this.squidStore.storeException(share_id, user_id, message, error);
    }
};

RecorderStore.prototype.getRecording = function(share_id, resolve)
{
    return this.arrayStore.getRecording(resolve);
};

var GuiMouseButtons = {
  LeftButton: 1,
  MiddleButton:2,
  RightButton: 3
};

var Collections = require("./src/collections/index.js");
/**
 * Registry for GuiEvent types.
 * @constructor
 */

var GuiEventTypes = function()
{
    this.id2Event = new Collections.HashMap();
};

/**
 * This is the singleton registry object where we register all gui event types.
 * GuiEvents will be filled up by statemachines in use.
 * @type {GuiEventTypes}
 */
var GuiEvents = new GuiEventTypes();

module.exports.GuiEvents = GuiEvents;

/**
 * Add list of unique events to the registry.
 * Every event must have a unique id over the total site that never changes: necessary to serialize event for recorder.
 * Example event list:
 * @example
 * {
 *      EDITOR_MOUSE_MOVE: {id: 'abs_2' , name: "EDITOR_MOUSE_MOVE" , isHoverAction: true},
 *      ..
 * }
 * @param {(Array | Object)} events An object or an array of objects who define guiEvents: see example
 */
GuiEventTypes.prototype.addEvents = function(events){

    for (var name in events) {
        if (events.hasOwnProperty(name)) {
            var event = events[name];

            /* adding helpers for transition condition */
            _addGuiEventHelpers(event);

            if (!this.id2Event.contains(event.id) && !this[name]) {
                this[name] = event;
                this.id2Event.put(event.id, event);
            } else {
                if(this[name]) {
                    if(this[name].id != event.id)
                        console.warn(name + " already exists.  using ID " + this[name].id + " instead of " + event.id);
                    // else
                        // console.log("Adding event again: " + name);
                }
                if(this.id2Event.contains(event.id)) {
                    if(this.id2Event.get(event.id).name != event.name)
                        console.error("There is already an event defined with id: " + event.id + ", unable to define new event with same id");
                }
            }
        }
    }

};

/**
 * Returns a GuiEventType or null identified by its id.
 * @param {String} id Id of the event
 * @returns {GuiEventType} a GuiEvent type
 */
GuiEventTypes.prototype.findEvent = function(id)
{
    return this.id2Event.get(id);
};

/**
 * Decorator to add convenience functions that create condition for transition test.
 * @param event
 * @private
 */
var _addGuiEventHelpers = function (event){
    /**
     * Create the function that will serve as a condition for a transition.
     * @param [dataAttributes] - hash of attributes to test against cEvent.data.
     */
    event.makeFilter = function(dataAttributes){
        var savedComposition = _.clone(event.composition);
        var chained = function(cEvent){
            var result = true;
            for (var i in savedComposition){
                if (savedComposition.hasOwnProperty(i)) {
                    var f = savedComposition[i];
                    result = result && f(cEvent);
                }
            }
            return (result && cEvent.dataMatches(dataAttributes));
        };
        event.composition = [event.isTypeOf];
        return(chained);
    };



    /**
     * The default check uses only the event type to determine the condition.
     * @param cEvent - Event to be tested.
     * @returns {function}
     */
    event.isTypeOf = function(cEvent){
        /* console.log((cEvent.type == event) == (cEvent.type.id == event.id)); // true */
        return (cEvent.type() == event);
    };

    /**
     * Modifier - The right mouse button is depressed.
     * @returns {GuiEvent} modified so that makeFilter will include right mouse button check.
     */
    event.right = function(){
        event.composition.unshift(function(cEvent){
            return (cEvent.data('which') == GuiMouseButtons.RightButton);
        });
        return event;
    };

    /**
     * Modifier - The right mouse button is depressed.
     * @returns {GuiEvent} modified so that makeFilter will include left mouse button check.
     */
    event.left = function(){
        event.composition.unshift(function(cEvent){
            return (cEvent.data('which') == GuiMouseButtons.LeftButton);
        });
        return event;
    };

    /**
     * Modifier - The middle mouse button is depressed.
     * @returns {GuiEvent} modified so that makeFilter will include middle mouse button check.
     */
    event.middle = function(){
        event.composition.unshift(function(cEvent){
            return (cEvent.data('which') == GuiMouseButtons.MiddleButton);
        });
        return event;
    };

    /**
     * Modifier - The shift key is depressed.
     * @returns {GuiEvent} modified so that makeFilter will include shift key check.
     */
    event.shift = function(){
        event.composition.unshift(function(cEvent){
            return (cEvent.data('shiftKey'));
        });
        return event;
    };

    /**
     * Modifier - The shift key is not depressed.
     * @returns {GuiEvent} modified so that makeFilter will include not(shift key) check.
     */
    event.noShift = function(){
        event.composition.unshift(function(cEvent){
            return (!cEvent.data('shiftKey'));
        });
        return event;
    };

    /**
     * Modifier - The ctrl key is depressed.
     * @returns {GuiEvent} modified so that makeFilter will include ctrl key check.
     */
    event.ctrl = function(){
        event.composition.unshift(function(cEvent){
            return (cEvent.data('ctrlKey'));
        });
        return event;
    };

    /**
     * Modifier - The ctrl key is not depressed.
     * @returns {GuiEvent} modified so that makeFilter will include not(ctrl key) check.
     */
    event.noCtrl = function(){
        event.composition.unshift(function(cEvent){
            return (!cEvent.data('ctrlKey'));
        });
        return event;
    };

    /**
     * Modifier - The alt key is depressed.
     * @returns {GuiEvent} modified so that makeFilter will include alt key check.
     */
    event.alt = function(){
        event.composition.unshift(function(cEvent){
            return (cEvent.data('altKey'));
        });
        return event;
    };

    /**
     * Modifier - The alt key is not depressed.
     * @returns {GuiEvent} modified so that makeFilter will include not(alt key) check.
     */
    event.noAlt = function(){
        event.composition.unshift(function(cEvent){
            return (!cEvent.data('altKey'));
        });
        return event;
    };

    event.composition = [event.isTypeOf];
};

/**
 * Create a new GuiEvent
 * @param type A type as registered in the {@link GuiEventTypes} registry.
 * @param {Object} element The element for which the event occured
 * @param {Object} jEvent JQuery event
 * @constructor
 */
var GuiEvent = function(type, element, jEvent)
{
    this._data = new Collections.HashMap();
    this._element = new Collections.HashMap();

    this._type  = type;
    this._scope = "";

    if (element) {
        this._element.put( 'element', element );
    }

    this.fromJSEvent( jEvent );
    this._timestamp = new Date().getTime();
    this._order = 0;
    this._start_ts = 0;
};

// GuiEvent.eventDiscriminator = 0;

GuiEvent.prototype.timestamp = function()
{
  return this._timestamp;
};

GuiEvent.prototype._accessor = function(map, property, value)
{
    if ( arguments.length == 2 &&  _.isString(property) ) {
        return map.get(property);
    } else if ( arguments.length == 2 && _.isObject(property) ) {
        _.each(_.keys(property), function(key) {
            map.put(key, property[key]);
        }, this);
        return this;
    } else {
        map.put(property, value);
        return this;
    }
};

/**
 * Set or get an element the event. An element can be (de)serialized by looking at the root.localIdMap.<br>
 *
 * If used with no parameters, return the default element, which has the name 'element'.<br>
 * If used with one parameter, the name of the element (string), you retrieve element.<br>
 * If used with one parameter, an object, the default 'element' is set to this object.<br>
 * If used with two parameters, the name of the element and its value, you assign that element to that property.<br>
 * This function returns the {GuiEvent} when setting an element, and as such allows for chaining.<br>
 *
 * @param {(String | Versioned)} property Property to get or set
 * @param {Versioned} [value] Versioned data object when setting an element
 * @returns {(GuiEvent | Versioned)} If you set an element this GuiEvent is returned for chaining, otherwise you get the requested data object.
 */
GuiEvent.prototype.element = function(property, value)
{
    if ( arguments.length == 0 ) {
        return this._accessor( this._element, 'element' );
    }
    if ( arguments.length == 1 && ! _.isString(arguments[0]) ) {
        return this._accessor( this._element, 'element', arguments[0] );
    }

    var args = Array.prototype.slice.call(arguments);
    args.unshift( this._element );
    return this._accessor.apply( this, args );
};

/**
 * Set or get a data value for the event. <br>
 *
 * If used with one parameter, the name of the property, you get the value of that property. <br>
 * If used with one parameter, an object, properties are set from the object. <br>
 * If used with two parameters, the name of the property and its value, you set the value of that property. <br>
 * This function returns the {GuiEvent} when setting a property, and as such allows for chaining.
 *
 * @param {(String | object)} property Property to get or set
 * @param {Object} [value] Value when setting a property
 * @returns {(GuiEvent | Object)} If you set a data property this GuiEvent is returned for chaining, otherwise you get the requested data object.
 */
GuiEvent.prototype.data = function(property, value)
{
    var args = Array.prototype.slice.call(arguments);
    args.unshift( this._data );
    return this._accessor.apply( this, args );
};

GuiEvent.prototype.fromJSEvent = function(jEvent)
{
    if ( ! jEvent ) {
        return;
    }

    _.each(
        {
            'keyCode': jEvent.keyCode,
            'metaKey': jEvent.metaKey,
            'pageX': jEvent.pageX,
            'pageY': jEvent.pageY,
            'shiftKey': jEvent.shiftKey,
            'which': jEvent.which,
            'ctrlKey': jEvent.ctrlKey,
            'altKey': jEvent.altKey
        },
        function(value, key){
            if (value != null) {
                this._data.put(key, value);
            }
        },
        this
    );

    /*jshint -W069 */
    /*Disable Warning Justification:
      Using bracket notation so Google Closure Compiler
      ADVANCED_OPTIMIZATIONS will keep the original property names. */
    if ( jEvent['gesture'] ) {
        var gesture = {};
        gesture.pageX = jEvent['gesture']['center']['pageX'];
        gesture.pageY = jEvent['gesture']['center']['pageY'];
        gesture.deltaX = jEvent['gesture']['deltaX'];
        gesture.deltaY = jEvent['gesture']['deltaY'];
        gesture.scale = jEvent['gesture']['scale'];
        this._data.put('gesture', gesture);
    }
    /*jshint +W069 */

    return this;
};

/**
 * Set or get the type of the event.
 * When called with no parameter, return the type of the event.
 * When called with one parameter, sets the type of the event.
 *
 * @param value
 * @returns {*}
 */
GuiEvent.prototype.type = function(value) {
    if (arguments.length == 0) {
        console.assert(this._type, 'undefined event type');
        return this._type;
    }

    this._type = value;

    return this;
};

/**
 * Set or get the scope of the event.
 *
 * @param value
 * @returns {*}
 */
GuiEvent.prototype.scope = function(value) {
    if (arguments.length == 0) {
        return this._scope;
    }

    this._scope = value;

    return this;
};

/**
 * If the event has a data section, return the keyCode associated or an empty string.
 * @returns {GuiEvent.data.keyCode|*}
 */
GuiEvent.prototype.getKey = function()
{
    return this._data.get('keyCode');
};

/**
 * Check if one the given keys are pressed with this event.
 * @param keys An array containing key strokes or an argument list.
 * @returns {boolean}
 */
GuiEvent.prototype.isKeyPressed = function(keys) {

    if (this._type != GuiEvents.GUI_KEY_PRESSED) return false;

    var list = (keys.constructor == Array) ? keys : arguments;

    var keyCodeFromEvent = this.getKey();

    for(var i=0; i < list.length; i++) {
        var keyCode = list[i];
        if (keyCodeFromEvent == keyCode) {
            return true;
        }
    }
    return false;
};

/**
 * Check if one the given keys is released with this event.
 * @param keys An array containing key strokes or an argument list.
 * @returns {boolean}
 */
GuiEvent.prototype.isKeyReleased = function(keys) {

    if (this._type != GuiEvents.GUI_KEY_RELEASED) return false;

    var list = (keys.constructor == Array) ? keys : arguments;

    var keyCodeFromEvent = this.getKey();

    for(var i=0; i < list.length; i++) {
        var keyCode = list[i];
        if (keyCodeFromEvent == keyCode) {
            return true;
        }
    }
    return false;
};

/**
 * Returns true if there are no required attributes or all data attributes match.
 * (modified from newer Underscore.js)
 *
 * @param {Object} object - object to be tested.
 * @param {Object} attrs - attribute list to test for in "object."
 * @returns {boolean}
 */
 GuiEvent.prototype.dataMatches = function(attrs) {
    if (!attrs) return true;
    var keys = _.keys(attrs), length = keys.length;

    for (var i = 0; i < length; i++) {
      var key = keys[i];
      if (attrs[key] !== this.data(key) || !(this._data.contains(key)) ) return false;
    }
    return true;
  };


/**
 * Set a member on the object if the value of that member is not null.
 *
 * @param object To set the value of a m,ember on
 * @param key
 * @param value
 * @private
 */
GuiEvent.prototype._setIfNotNull = function( object, key, value)
{
    if (value != null) {
        object[key] = value;
    }
};

/**
 * Return a serialized version of the event.
 * @param root
 * @returns {{type: *, objEvent: *, event: *, element: *, subelement: *, parent: *, terminal: *, data: *}}
 */
GuiEvent.prototype.serialize = function(root)
{
    /*jshint -W069 */
    /*Disable Warning Justification:
      Using bracket notation so Google Closure Compiler
      ADVANCED_OPTIMIZATIONS will keep the original property names. */
    var event = {};

    console.assert(this._type, "event without type");
    event['name']  = this._type.name;
    event['type']  = this._type.id;

    this._setIfNotNull( event, 'data',      this._serializeData(this._data) );
    this._setIfNotNull( event, 'element',   this._serializeElements(this._element) );

    event['timestamp'] = this._timestamp;
    event['start_ts'] = this._start_ts;
    event['order'] = this._order;

    return event;
    /*jshint +W069 */
};

/**
 * Deserialize an event
 * @param root
 * @param event
 * @returns {GuiEvent}
 */
GuiEvent.prototype.deserialize = function(root, modelRoot, event)
{
    /*jshint -W069 */
    /*Disable Warning Justification:
      Using bracket notation so Google Closure Compiler
      ADVANCED_OPTIMIZATIONS will keep the original property names. */
    this._type = GuiEvents.findEvent(event['type']);
    console.assert(this._type, "Event with unknown type: "+event['type']);
    this._data = this._deserializeData(event['data']);
    this._element = this._deserializeElements(root, modelRoot, event['element']);
    this._timestamp = event['timestamp'];
    this._start_ts = event['start_ts'];
    this._order = event['order'];
    /*jshint +W069 */

    return this;
};

GuiEvent.prototype._serializeData = function(data)
{
    if ( 0 == data.size() ) {
        return null;
    }

    var copy = data.copy();

    if (copy.get('mouseCoord')) {
        copy.put( 'mouseCoord', {'x' : copy.get('mouseCoord').x, 'y' : copy.get('mouseCoord').y } );
    }

    if (copy.get('gesture')) {
        var gesture = copy.get('gesture');
        copy.put(
            'gesture',
            {
                'pageX':  gesture.pageX,
                'pageY':  gesture.pageY,
                'deltaX': gesture.deltaX,
                'deltaY': gesture.deltaY,
                'scale':  gesture.scale
            }
        );
    }

    var json = {};
    copy.forEach(function(key, val){
        json[key] = val;
    });
    return json;
};

/*jshint -W069 */
/*Disable Warning Justification:
 Using bracket notation so Google Closure Compiler
 ADVANCED_OPTIMIZATIONS will keep the original property names. */
GuiEvent.prototype._deserializeData = function(data)
{
    var map = new Collections.HashMap();

    _.each(_.keys(data), function(key){
        map.put( key, data[key] );
    });

    var mouseCoord = map.get('mouseCoord');
    if (mouseCoord) {
        mouseCoord["$class"] = "Coordinate";
        map.put( 'mouseCoord', JsonParser.dejsonifyValue(mouseCoord) );
    }

    var gesture = map.get('gesture');
    if (gesture) {

       gesture.pageX = gesture['pageX'];
       gesture.pageY = gesture['pageY'];
       gesture.deltaX = gesture['deltaX'];
       gesture.deltaY = gesture['deltaY'];
       gesture.scale = gesture['scale'];
       map.put( 'gesture', gesture );
    }

    return map;
};
/*jshint -W069 */

GuiEvent.prototype._serializeElements = function(elementsMap)
{
    var elements = {};

    elementsMap.forEach(function(name, element){
        if(!element){
            throw new Error("Serialize needs an element.");
        }
        if (!element.$localId){
            throw new Error("Serialize needs an element with a local_id property.");
        }
        elements[name] = element.$localId;
    });

    return elements;
};

GuiEvent.prototype._deserializeElements = function(root, modelRoot, elements)
{
    var map = new Collections.HashMap();

    _.each(elements, function(localId, name){
        var element = root.localIdMap.get(localId) || modelRoot.localIdMap.get(localId);
        if(element == undefined)
            throw new Error("No element found with this local id: "+localId);
        map.put( name, element );
    }, this);

    return map;
};

module.exports.GuiEvent = GuiEvent;

/**
 * The recorder can record and play statemachine events.
 * With the recorder we can record all the actions a user took to create a project.
 *
 *
 * In the chrome shell, you can access the circuits recorder with the ecorder global.
 * Here's an example session:
 * @example
 * recorder.start()
 * ( do stuff )
 * recorder.stop()
 * recorder.download()
 * ( save record.json to your computer )
 * recorder.resetCircuit() (deprecated)
 * ( in a shell ... cat record.json | pbcopy ... if you live in OSX )
 * recorder.playJSON(...paste...)
 * ( enjoy the movie )
 *
 * @constructor
 */
var Recorder = function(recording)
{
    this.recording = recording;
    this.verbose = false;
    this.statemachine = null;
    this.playing = false;
    this.store = new RecorderStore(recording);
    this.shareId = null;
    this._loaded = false;
};

module.exports.Recorder = Recorder;

Recorder.prototype.setShareId = function(shareId) {
    this.shareId = shareId;
};

Recorder.prototype.persist = function(endpoint, afcToken, userId)
{
    this.store.persist({ endpoint: endpoint, afc: afcToken });
    this.recording = true;
    this.userId = userId;
};

/**
 * Set the toplevel statemachine. Must be done before we can record events.
 *
 * @param statemachine
 */
Recorder.prototype.setStatemachine = function(statemachine)
{
    this.statemachine = statemachine;
};

Recorder.prototype.setRoots = function(root, modelRoot) {
    this.root = root;
    this.modelRoot = modelRoot;
};

    /**
     * Record a guiEvent
     * @param guiEvent
     */
    Recorder.prototype.record = function(guiEvent) {
        if (this.playing) return;

        if(this.recording) {
            this.store.addEvent(this.shareId, this.userId, guiEvent);
        }
    };

    /**
     * Record an exception
     *
     * @param message
     * @param error
     */
    Recorder.prototype.storeException = function (message, error) {
        if (this.recording) {
            this.store.storeException(this.shareId, this.userId, message, error);
        }
    };

    /**
     * Start recording.
     * Overwrites the previous recording.
     */
    Recorder.prototype.start = function () {
        this.recording = true;
        this.store.recordInMemory = true;
    };

    /**
     * Stops recording.
     */
    Recorder.prototype.stop = function () {
        this.recording = false;
        this.store.recordInMemory = false;
    };

    /**
     * Returns a JSON encoded recording.
     *
     * This can further be stringified by JSON.stringify().
     *
     * @returns {*}
     */
    Recorder.prototype.save = function (resolve) {
        this.store.getRecording(this.shareId, resolve);
    };

    Recorder.prototype.name = function () {
        if (this._name) {
            return this._name;
        }
        return this.shareId;
    };

    Recorder.prototype.setName = function (name) {
        this._name = name;
    };

    Recorder.prototype._download = function (filename, data) {
        var blob = new Blob([data], {type: 'text/plain'});
        var blobUrl = URL.createObjectURL(blob);
        var download = document.createElement('a');
        download.href = blobUrl;
        download.setAttribute('download', filename);
        var event = document.createEvent("MouseEvents");
        event.initMouseEvent("click", true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
        download.dispatchEvent(event);
    };

    /**
     * Presents a save file for the current recording.
     */
    Recorder.prototype.download = function (filename) {
        if (!this.store.recordInMemory) {
            console.error("Activate recording before downloading, append '?recording=true' to the URL.");
            return;
        }
        var self = this;
        this.save(function (err, data) {
            if (err) {
                console.error("Could not retrieve recording.", err);
                return;
            }
            self._download(self.name() + '.json', JSON.stringify(data));
        });
    };

    /**
     * Plays a recording from a stringified JSON representation of a previous recording.
     * @param serializedEventsAsJson
     */
    Recorder.prototype.play = function (serializedEventsAsJson) {
        var serializedEvents = JSON.parse(serializedEventsAsJson);
        this.playJSON(serializedEvents);
    };

    /**
     * Replay the current recording.
     */
    Recorder.prototype.replay = function () {
        this.stop();
        this.store.getRecording(this.shareId, function (recording) {
            this.playJSON(recording);
        });
    };

    /**
     * Plays the events from a recording.
     *
     * @param recording
     */
    Recorder.prototype.playJSON = function (compressedRecording, callback, sync, timeout) {
        var compressor = new EventsCompressor({
                types: [ 'EDITOR_MOUSE_MOVE', 'CANVAS_MOUSE_MOVE' ],
                factor: 50
            });
        var recording = compressor.decompress(compressedRecording);
        if(sync)
            this.playEventsSync(this, recording['events'], callback);
        else
            this.playEventsAsync(this, recording['events'], 0, callback, timeout);
    };

    Recorder.prototype.playJSONPromise = function (compressedRecording, sync) {
        var self = this;
        return new Promise(function(resolve, reject) {
            self.playJSON(compressedRecording, function(events, index, error) {
                if(error)
                    reject(error);
                else
                    resolve();
            }, sync);
        });
    };

    /**
     * This is the async loop that plays all events in a list.
     *
     * @param self
     * @param events
     * @param index
     * @param callback
     */
    Recorder.prototype.playEventsAsync = function (self, events, index, callback, timeout) {
        this.playing = true;

        if (index >= events.length) {
            if (callback) {
                callback.call(self, events, index);
            }
            this.playing = false;
            return;
        }

        //if (events[index].type === "abs_2") {
        //    while (index < events.length && events[index].type === "abs_2") index++;
        //    index--; //Play last Mouse_move
        //}

        try {
            this.playEventAt(events, index, true);
        } catch (e) {
            console.log("Exception occured, we halt replay now");
            if (callback) {
                callback.call(self, null, null, e);
            }
            return;
        }

        /* Here we recursively play the next event after a setTimeout to yield
         so javascript has a change to take other work from the event queue.
         As a timeout value, 0 also seems to work, but on zooming 1 gives a more stable result.
         Ideally, we introduce a continuation for when the stateMachine's work is done.
         */

        //if (events[index+1].type === "abs_2") {
        //    while (events[index+1].type === "abs_2") index++;
        //    index--; //Play last Mouse_move
        //}


        if(timeout !== undefined) {
            setTimeout(function () {
                self.playEventsAsync(self, events, index + 1, callback, timeout);
            },timeout);
        } else {
            setImmediate(function () {
                self.playEventsAsync(self, events, index + 1, callback, timeout);
            });
        }
    };


    /**
     * This is the async loop that plays all events in a list.
     *
     * @param self
     * @param events
     * @param index
     * @param callback
     */
    Recorder.prototype.playEventsSync = function (self, events, callback) {
        this.playing = true;

        for(var index = 0; index<events.length; index++)
            this.playEventAt(events, index, true);

        this.playing = false;
        if (callback) callback();
    };

    /**
     * Play the event at index in the events array.
     *
     * @param events
     * @param index
     */
    Recorder.prototype.playEventAt = function(events, index, throwFlag)
    {
        try {
            var needBreak = false;
            var event = events[index];
            if (this._breakpoint && this._breakpoint == index) needBreak = true;
            if (this._break_on_event) {
                /*
                 if (this._break_on_event.name && this._break_on_event.name == event.name) needBreak = true;
                 if (this._break_on_event.element && event.element && this._break_on_event.element == event.element.element) needBreak = true;
                 */
                if (this._break_on_event.name && this._break_on_event.name == event.name) {
                    if (this._break_on_event.element && event.element && this._break_on_event.element == event.element.element) {
                        needBreak = true;
                    }
                }
            }
            this.playEvent(event, needBreak);
            return true;
        } catch(e) {
            console.log("Error while replaying event #%d", index);
            console.log(e.stack);
            console.log(events[index]);
            if(throwFlag)
                throw e;
            return false;
        }
    };

    /**
     * Play one serialized event.
     *
     * @example
     *
     * You can also inject an event with this method.
     * Here's an example on how to inject a zoom to fit:
     *
     * ecorder.playEvent({
     *    "type": "abs_11",
     *    "data": {
     *      "code": "90",
     *      "keyCode": "z",
     *      "mouseCoord": {
     *        "x": 828,
     *        "y": 177,
     *        "lengthCache": null,
     *        "normCache": null
     *      }
     *    },
     *    "event": {
     *      "keyCode": 90,
     *      "metaKey": false,
     *      "ctrlKey": false,
     *      "shiftKey": false,
     *      "which": 90,
     *      "gesture": {}
     *    }
     *  });
     *
     * @param event
     */
    Recorder.prototype.playEvent = function(event, needBreak)
    {
        var guiEvent = new GuiEvent();
        guiEvent.deserialize(this.root, this.modelRoot, event);
        if (needBreak) {
            debugger;
        }
        this.statemachine.handleTransition(guiEvent);
    };

    var rWasException = false;
    var rEvents = [];
    var rPlay = false;
    var rCompressor = null;
    var rReady = true;
    var rIndex = -1;
    Recorder.prototype.playEventJSON = function(eventJSON, needBreak, index) {
        rIndex = index;

        var self = this;

        if (rCompressor === null) {
            rCompressor = new EventsCompressor({
                types: ['EDITOR_MOUSE_MOVE', 'CANVAS_MOUSE_MOVE'],
                factor: 50
            });
        }

        function _play() {
            if (rPlay == false) return;
            var ej = rEvents.shift();
            if (ej === undefined ) {
                rReady = true;
                setTimeout(function(){ _play(); }, 1);
                return;
            }
            rReady = false;
            var guiEvent = new GuiEvent();
            guiEvent.deserialize(self.root, self.modelRoot, ej.e);
            if (ej.b) debugger;
            var hasException = false;
            try {
                self.statemachine.handleTransition(guiEvent);
            } catch(e) {
                hasException = true;
            }
            if (hasException) {
                 rWasException = true;
            } else {
                 setTimeout(function () { _play(); }, 1);
            }
        }

        var event = JSON.parse(eventJSON);
        var brk = needBreak;
        rCompressor.decompressEvent(event, function(evt){
            rEvents.push({e: evt, b: brk});
            brk = false;
        });

        if (rPlay === false) {
            rPlay = true;
            this.playing = true;
            _play();
        }
    };

    Recorder.prototype.stopEventJSON = function(){
        rPlay = false;
        this.playing = false;
    };

    Recorder.prototype.readyEventJSON = function() {
        return { ready: rReady, wasException: rWasException, index: rIndex };
    };

    Recorder.prototype.loaded = function() {
        return this._loaded;
    };

    Recorder.prototype.resetLoaded = function() {
        this._loaded = false;
    };

    Recorder.prototype.setLoaded = function() {
        this._loaded = true;
    };

    /**
     * Download the root.data model as JSON.
     *
     * This call opens a file requester to download the model as JSON to local disk.
     */
    Recorder.prototype.downloadCircuitSnapshot = function () {
        this._download(this.name() + '.snapshot.json', JSON.stringify(this.saveCircuitSnapshot()));
    };

    /**
     * Returns the root.data model as JSON.
     *
     * @returns {*} JSON representation of root.data
     */
    Recorder.prototype.saveCircuitSnapshot = function () {
        return this.root.jsonify();
    };

    /**
     * Download the root.editorModel as JSON.
     *
     * This call opens a file requester to download the model as JSON to local disk.
     */
    Recorder.prototype.downloadEditorModel = function () {
        this._download(this.name() + '.editormodel.json', JSON.stringify(this.saveEditorModel()));
    };

    /**
     * Returns the root.editorModel as JSON.
     *
     * @returns {*} JSON representation of root.data
     */
    Recorder.prototype.saveEditorModel = function () {
        return this.modelRoot.jsonify();
    };

    /**
     * Provide a window with a file upload button.
     *
     * Use this method when you need to upload a large recording that would otherwise clog the developer console.
     */
    Recorder.prototype.uploadJSON = function () {
        var self = this;
        var w = window.open("", "recorder", "menubar=no,location=no,resizable=no,scrollbars=no,status=no,height=256,width=320");
        w.document.body.innerHTML = "<div><p>Choose a recording...</p><input type=\"file\" id=\"input\"></div>";
        w.document.getElementById("input").addEventListener("change", function () {
            var reader = new FileReader();
            reader.onload = function () {
                var data = reader.result;
                var json = JSON.parse(data);
                self.playJSON(json);
            };
            reader.onerror = function () {
                console.error(reader.error);
            };
            reader.onloadend = function () {
                w.close();
            };
            reader.readAsText(this.files[0]);
        }, false);
    };

    Recorder.prototype.breakpoint = function(line) {
        this._breakpoint = line;
    };

    Recorder.prototype.break_on_event = function(eventDescription) {
        this._break_on_event = eventDescription;
    };

    /**
     * Define the public API for recorder.
     *
     * We have to export prototype properties we want to use via the API as strings.
     */
    Recorder.prototype["playEvent"] = Recorder.prototype.playEvent;
    Recorder.prototype["playEventAt"] = Recorder.prototype.playEventAt;
    Recorder.prototype["play"] = Recorder.prototype.play;
    Recorder.prototype["playJSON"] = Recorder.prototype.playJSON;
    Recorder.prototype["replay"] = Recorder.prototype.replay;
    Recorder.prototype["start"] = Recorder.prototype.start;
    Recorder.prototype["stop"] = Recorder.prototype.stop;
    Recorder.prototype["save"] = Recorder.prototype.save;
    Recorder.prototype["download"] = Recorder.prototype.download;
    Recorder.prototype["resetCircuit"] = Recorder.prototype.resetCircuit;
    Recorder.prototype["playEventsAsync"] = Recorder.prototype.playEventsAsync;
    Recorder.prototype["downloadCircuitSnapshot"] = Recorder.prototype.downloadCircuitSnapshot;
    Recorder.prototype["saveCircuitSnapshot"] = Recorder.prototype.saveCircuitSnapshot;
    Recorder.prototype["downloadEditorModel"] = Recorder.prototype.downloadEditorModel;
    Recorder.prototype["saveEditorModel"] = Recorder.prototype.saveEditorModel;
    Recorder.prototype["uploadJSON"] = Recorder.prototype.uploadJSON;
